<template>
  <input-popover v-model:open="isOpen" class="z-10" :position="isMobile ? 'top-end' : 'bottom-end'">
    <template #trigger>
      <button
        v-if="isMobile"
        class="flex h-14 w-14 cursor-pointer items-center justify-between rounded-full border-2 border-gray-800 bg-gray-700"
        data-cy="funding-advisor-details-toggle"
      >
        <icon-phone class="w-full text-green-500" />
      </button>
      <div
        v-else
        class="flex items-center justify-between space-x-2 rounded-full bg-gray-700 p-1"
        :class="[{ 'pl-5': !advisor.telephone }, hasDetails ? 'hover:bg-gray-600' : 'pr-5']"
      >
        <a
          v-if="advisor.telephone"
          :href="`tel:${advisor.telephone}`"
          data-cy="funding-advisor-phone"
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full hover:bg-gray-500"
          @click.stop
        >
          <icon-phone class="text-green-500" />
        </a>
        <div
          data-cy="funding-advisor-name"
          class="flex flex-col"
          :class="{ 'cursor-pointer': hasDetails }"
        >
          <span class="text-sm text-branding-heading">
            {{ advisor.first_name }} {{ advisor.last_name }}
          </span>
          <span class="text-xs text-gray-400">{{ $t("role.fundingAdvisor") }}</span>
        </div>
        <button
          v-if="hasDetails"
          data-cy="funding-advisor-details-toggle"
          class="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full"
        >
          <icon-arrow fill="currentColor" :class="isOpen ? '-rotate-90' : 'rotate-90'" />
        </button>
      </div>
    </template>
    <template #content>
      <platform-contact-details v-if="isMobile || hasDetails" class="min-w-60" :advisor="advisor" />
    </template>
  </input-popover>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import IconArrow from "@/components/icons/IconArrow.vue";
import IconPhone from "@/components/icons/IconPhone.vue";
import InputPopover from "@/components/input/InputPopover.vue";
import type { FundingAdvisor } from "@/api/http/schemas/applicationSchemas";
import PlatformContactDetails from "@/components/platform/PlatformContactDetails.vue";
import { useResponsive } from "@/composables/common";

const props = defineProps<{
  advisor: FundingAdvisor;
}>();

const { isMobile } = useResponsive();
const isOpen = ref(false);

const hasDetails = computed(() => {
  return !!props.advisor.telephone || !!props.advisor.calendar_link;
});
</script>
